import style from "../services/styles"

const { COLORS } = style

export default {
    IMAGE: { value: 1, label: 'Imagem', style: { color: COLORS.GREEN[900] } },
    VIDEO: { value: 2, label: 'Vídeo', style: { color: COLORS.GREEN[900] } },
    TEXT: { value: 3, label: 'Texto', style: { color: COLORS.GREEN[900] } },
}